const services = [
  {
    icon: 'ri-user-heart-line',
    title: 'Personal Care Assistance',
    description:
      'Our trained caregivers assist residents with daily activities including bathing, grooming, dressing, and mobility — always with dignity and respect.',
    image: 'https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=600&q=80&fit=crop&crop=center',
  },
  {
    icon: 'ri-medicine-bottle-line',
    title: 'Medication Management',
    description:
      'We ensure every resident receives the right medication at the right time. Our licensed staff coordinate with physicians to manage prescriptions safely.',
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&q=80&fit=crop&crop=center',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Nutritious Meals & Dining',
    description:
      'Home-cooked, balanced meals prepared fresh daily with special dietary accommodations. We make dining a social, joyful experience for all residents.',
    image: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=600&q=80&fit=crop&crop=center',
  },
  {
    icon: 'ri-run-line',
    title: 'Social & Wellness Activities',
    description:
      'Engaging activities, gentle exercises, and social events keep residents mentally and physically active — fostering friendship and a sense of belonging.',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80&fit=crop&crop=center',
  },
  {
    icon: 'ri-hospital-line',
    title: 'Health Monitoring',
    description:
      "Regular health assessments and coordination with medical professionals ensure that each resident's well-being is consistently monitored and supported.",
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&q=80&fit=crop&crop=center',
  },
  {
    icon: 'ri-home-heart-line',
    title: 'Comfortable Living Spaces',
    description:
      'Private and semi-private rooms designed to feel like home, with housekeeping, laundry services, and beautiful common areas for relaxation.',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600&q=80&fit=crop&crop=center',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 md:py-28 bg-sky-50">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs tracking-widest uppercase text-sky-600 font-semibold mb-3">
            What We Offer
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
            Care Services Designed<br />Around You
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Every service at Pure Care is crafted to meet the unique needs of each resident, ensuring comfort, health, and happiness every day.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="bg-white rounded-2xl overflow-hidden border border-sky-100 hover:-translate-y-1 transition-transform duration-300 group"
            >
              {/* Image */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={svc.image}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-sky-50">
                    <i className={`${svc.icon} text-sky-600 text-sm`}></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 text-sm">{svc.title}</h3>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed">{svc.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom highlights */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 bg-white rounded-2xl border border-sky-100 p-8">
          {[
            { icon: 'ri-time-line', label: 'Open 24/7', sub: 'Staff available around the clock' },
            { icon: 'ri-shield-check-line', label: 'Licensed & Insured', sub: 'Fully certified in Minnesota' },
            { icon: 'ri-heart-line', label: 'Personalized Care', sub: 'Plans tailored to each resident' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center text-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-sky-50">
                <i className={`${item.icon} text-sky-600 text-lg`}></i>
              </div>
              <div className="text-sm font-semibold text-gray-900">{item.label}</div>
              <div className="text-xs text-gray-500">{item.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
